import React, { useState } from 'react'
import './styles/Select.scss'

import { normalizeAccents } from 'util/index'

type ItensOpts = { key: any, value: any }

type SearchOpts = {
  itens: ItensOpts[],
  selected?: ItensOpts['value'],
  required?: boolean,
  disabled?: boolean,
  placeholder?: string,
  onSelect: (key: ItensOpts['key']) => void
}
const Select: React.FC<SearchOpts> = ({
  selected = '', required = false, disabled = false, placeholder, onSelect, itens
}) => {
  const [isFocused, setFocus] = useState(false)
  const [search, setSearch] = useState('')

  function handleClick (key: ItensOpts['key']): void {
    onSelect(key)
    setSearch('')
    setFocus(false)
  }

  function sanitize (str: string): string {
    return normalizeAccents(str).toLocaleLowerCase()
  }

  const list = itens.filter(item => !search || sanitize(String(item.value)).search(sanitize(search)) > -1)

  const findSelected = itens.find(item => String(item.key) === String(selected))

  return (
    <div className="row select">
      <input
        type="text"
        value={search || findSelected?.value || ''}
        autoComplete="new-password"
        disabled={disabled}
        required={required}
        onFocus={(): void => setFocus(true)}
        placeholder={placeholder}
        onBlur={(): void => {
          setTimeout(() => setFocus(false), 500)
        }}
        onChange={(e): void => {
          setSearch(e.target.value)
          onSelect('')
        }}
      />
      {
        !!(list.length && isFocused) &&
        <div className="search-box">
          {
            list.map(item => {
              return (
                <div
                  key={item.key}
                  onClick={(): void => handleClick(item.key)}
                  className={`search-item ${selected === item.key ? 'active' : ''}`}
                >
                  { item.value }
                </div>
              )
            })
          }
        </div>
      }
      {
        !list.length && search &&
        <div className="search-box">
          <div className='search-item' >
            Nenhum item encontrado
          </div>
        </div>
      }
    </div>
  )
}

export default Select
